import React from "react";
import "../styles/contact.css";
import Marque from "./Marque";
import BigText from "./BigText";
import ContactCard from "./ContactCard";
import IconCard from "./IconCard";
import GotoCard from "./GotoCard";
import McLogoFull from "../images/mclogofull.png";

import GlowShade from "./GlowShade";

import { useAudio } from "./AudioContext";

export default function Contact() {
  const { playAudio, playHover, pauseHover } = useAudio();

  const handleClick = () => {
    playAudio();
  };

  const handleMouseEnter = () => {
    playHover(0.3);
  };

  const handleMouseLeave = () => {
    pauseHover();
  };

  return (
    <div className="contact">
      <Marque text={"Contact"} id={"contact"} />
      <BigText text={"Let's"} align="left" top="150px" top2="140px" />
      <BigText text={"Connect"} align="left" top="150px" top2="140px" />

      <GlowShade
        color="#00A86B"
        top="80%"
        left="-4%"
        top2="120%"
        height="200px"
        width="200px"
      />
      <a
        href="mailto:ramahesh024@gmail.com"
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <ContactCard
          icon={"fi fi-rr-envelope"}
          text={"ramahesh024@gmail.com"}
          top={"200px"}
          top2={"260px"}
        />
      </a>
      <a
        href="tel:+918639838411"
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <ContactCard
          icon={"fi fi-rr-phone-call"}
          text={"+91 8639838411"}
          top2={"380px"}
        />
      </a>
      <div className="middle">
        <IconCard
          icon={"fi fi-brands-linkedin"}
          link={"https://www.linkedin.com/in/cheegitimahesh"}
        />
        <IconCard
          icon={"fi fi-brands-github"}
          link={"https://github.com/Maheshcheegiti"}
        />
        <IconCard
          icon={"fi fi-brands-twitter-alt"}
          link={"https://twitter.com/maheshaaryan24"}
        />
        <IconCard
          icon={"fi fi-brands-instagram"}
          link={"https://www.instagram.com/mahesh_aaryan_"}
        />
        <IconCard
          icon={"fi fi-brands-facebook"}
          link={"https://www.facebook.com/profile.php?id=100010724285143"}
        />
      </div>
      <GotoCard
        title={"Freelancer"}
        text={
          "Interested in working together or have a question? Feel free to reach out to discuss your project. You can contact me via email or phone."
        }
        link={"#contact"}
        left={"12%"}
        left2={"5%"}
        top={"90%"}
        top2={"135%"}
      />
      <GotoCard
        title={"Works"}
        text={
          "Check out my works and Projects, from buidling websites to design and more."
        }
        link={"#works"}
        left={"7%"}
        left2={"15%"}
        top={"130%"}
        top2={"165%"}
      />
      <GotoCard
        title={"Resume"}
        text={"See my resume, experience, education, my work history and more."}
        link={"#resume"}
        left={"30%"}
        top={"120%"}
        left2={"10%"}
        top2={"190%"}
      />

      <GlowShade
        color="#824581"
        top="60%"
        left="80%"
        top2="200%"
        left2="50%"
        height="200px"
        width="200px"
      />

      <GotoCard
        title={"Skills"}
        text={
          "Check out my skills, from programming to design, development and more."
        }
        link={"#skills"}
        left={"55%"}
        top={"110%"}
        left2={"55%"}
        top2={"155%"}
      />

      <GotoCard
        title={"Experience"}
        text={
          "Check out my experience, where I have worked, what I have done and more."
        }
        link={"#experience"}
        left={"70%"}
        top={"90%"}
        left2={"55%"}
        top2={"130%"}
      />

      <GotoCard
        title={"Milestones"}
        text={"Check out my milestones, achievements, certifications and more."}
        link={"#milestones"}
        left={"80%"}
        top={"120%"}
        left2={"60%"}
        top2={"180%"}
      />

      <div className="mclogo">
        <div className="pos">
          <img src={McLogoFull} alt="McLogoFull" className="mclogo" />
          <div>
            <p>
              &copy; 2024 Cheegiti Mahesh{" "}
              <span role="img" aria-label="india">
                🇮🇳
              </span>
            </p>
          </div>
        </div>
      </div>
      <GlowShade
        color="#00BBFF99"
        top="140%"
        left="70%"
        top2="80%"
        left2="50%"
        height="200px"
        width="200px"
      />
    </div>
  );
}
